import { withTranslation } from 'react-i18next';
import ToggleSortButtons from './ToggleSortButtons';

export default withTranslation()(ToggleSortButtons);
